export default __webpack_public_path__ + "static/char-03-55044f73867653af1facb99a3b04f0d6.gif";